var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('feather-icon',{attrs:{"icon":"EditIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.editRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }